module.exports = __webpack_public_path__ + "media/images/get-hired-dff089ac9c716f6edf66c1fc551033f2.svg";